'use client';

import React, { useState, useEffect } from 'react';
import Slider from '@/components/ui/Slider';
import links from './newlinks.json';
import openArrow from '../../../public/images/arrow-up-right-from-square.png';

const IndustryHighlights: React.FC = () => {
  const [slideWidth, setSlideWidth] = useState(33.33);

  useEffect(() => {
    const update = () => {
      if (window.innerWidth < 640) setSlideWidth(92);
      else if (window.innerWidth < 1024) setSlideWidth(50);
      else setSlideWidth(33.33);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return (
    <Slider showArrows infinite slideWidth={slideWidth}>
      {links.map((item, index) => (
        <div key={index} className="px-2 h-full">
          <div className="bg-white rounded-lg shadow-lg border border-[#E1EEFE] p-5 flex flex-col h-full">
            {/* Image — fixed height for consistency across all cards */}
            <div className="w-full h-48 rounded-lg overflow-hidden flex-shrink-0 mb-4 bg-[#f5f7fa]">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-contain"
              />
            </div>

            {/* Source */}
            <span className="text-[#486075] text-sm font-normal mb-1 flex-shrink-0">
              {item.source}
            </span>

            {/* Title */}
            <div
              className="text-[#212A31] text-base font-medium leading-6 mb-2 flex-shrink-0"
              dangerouslySetInnerHTML={{ __html: item.title }}
            />

            {/* Description — full text, no truncation */}
            <p className="text-[#212A31] text-sm font-normal leading-[160%] flex-1">
              {item.description}
            </p>

            {/* Link */}
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#2067F3] font-medium text-sm inline-flex items-center gap-2 mt-4 flex-shrink-0"
            >
              <img src={openArrow.src} alt="" className="w-4 h-4 flex-shrink-0" />
              <span>{item.button}</span>
            </a>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default IndustryHighlights;
